<template>
    <div class="flex items-center mb-md">
        <h4 class="headline-sm font-semibold">
            {{ title }}
        </h4>

        <div class="relative">
            <div
                v-tooltip.right="helpText"
                class="ml-md help-button"
            >
                <font-awesome-icon icon="question" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                required: true,
                type: String,
            },
            helpText: {
                required: true,
                type: String,
            },
        },
    };
</script>